import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IParametrizations } from "interfaces";

const { Title, Text } = Typography;

export const PresencePointsShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IParametrizations>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Chave</Title>
      <Text>{record?.Key}</Text>

      <Title level={5}>Valor</Title>
      <Text>{record?.Value}</Text>
    </Show>
  );
};
